module.exports = __webpack_public_path__ + "static/img/003.5abf94a3.png";